import { useEffect } from "react";
import i18n from "@helpers/i18n";

import useResponsive from "@hooks/useResponsive";
import { StepsDrawerConsumer } from "@contexts/StepsDrawerProvider";

const useStepsDrawer = props => {
  const isLaptopOrDesktop = useResponsive("up", "md");
  const stepsDrawerCtxt = StepsDrawerConsumer();
  const open = isLaptopOrDesktop ? true : stepsDrawerCtxt.state.open;

  const {
    isCobLoading,
    hasFormValidationErrors,
    caseId,
    cobForm,
    customer,
    steps,
    viewNumber,
    currentWorkflow,
    readOnly,
    onToggle,
    onShareOpen,
    showCaseSessionDialog,
    toggleCaseSessionDialog
  } = props;

  const selectedChild = stepsDrawerCtxt.state.selectedChild;
  const seenViews =
    JSON.parse(localStorage.getItem(`SEEN_VIEWS_${btoa(customer.caseId)}`)) ||
    [];

  const customProps = {
    variant: isLaptopOrDesktop ? "permanent" : "temporary"
  };

  const toggleDrawer = () => e => {
    if (
      isLaptopOrDesktop ||
      (e && e.type === "keydown" && (e.key === "Tab" || e.key === "Shift"))
    ) {
      return;
    }
    return stepsDrawerCtxt.toggleDrawer();
  };

  // // Handle parent menu item click
  // const handleItemClick = item => e => {
  //   e.preventDefault;
  //   if (item.children) {
  //     if (stepsDrawerCtxt.state.nestedItems !== item.name) {
  //       stepsDrawerCtxt.setNestedItems(item.name);
  //     }

  //     return;
  //   }

  //   item.handleNavigation();
  //   stepsDrawerCtxt.setState(prevState => ({
  //     ...prevState,
  //     selectedChild: null
  //   }));

  //   // scroll to top
  //   window.scrollTo(0, 0);
  //   if (isLaptopOrDesktop) return;
  //   return stepsDrawerCtxt.toggleDrawer();
  // };

  // Handle nested children click
  const handleChildClick = child => e => {
    e.preventDefault;
    if (isCobLoading) return;

    child.handleNavigation();

    stepsDrawerCtxt.setState(prevState => ({
      ...prevState,
      selectedChild: child.name
    }));
    // scroll to top
    // window.scrollTo(0, 0);
  };

  const menu = [];
  if (steps && steps.length > 0) {
    steps.forEach(view => {
      const { id, label, viewIndex, subViews } = view;

      if (subViews && subViews.length > 0) {
        const children = [];

        subViews.forEach((subView, index) => {
          const {
            label,
            isDisabledForCompanies,
            isDisabledForPersons,
            getInitialState,
            isViewFulfilled,
            useAlternativeViewFulfillment
          } = subView;

          if (
            (isDisabledForCompanies && customer.isCompany) ||
            (isDisabledForPersons && !customer.isCompany)
          ) {
            return;
          }

          const initialViewState = getInitialState(customer, currentWorkflow);
          let isFulfilled = useAlternativeViewFulfillment
            ? isViewFulfilled.call(this, initialViewState)
            : isViewFulfilled(initialViewState);
          if (viewIndex === "1") {
            isFulfilled = true; // The start page is always fulfilled once we display the ProgressIndicator
          }

          // check if view is in seenViews
          const hasBeenSeen = readOnly ? true : seenViews.includes(viewIndex);

          const subMenuItem = {
            index: index,
            name: subView.id,
            label,
            hasBeenSeen,
            isFulfilled,
            handleNavigation: () => {
              stepsDrawerCtxt.setSelectedChild(subView.id);
              cobForm.current._onSubmit(null, {
                triggeredFrom: "CobStepsButton",
                viewIndex: subView.subViewIndex
              });

              if (!isLaptopOrDesktop) stepsDrawerCtxt.toggleDrawer();
            }
          };
          children.push(subMenuItem);
        });

        const menuItem = {
          index: viewIndex,
          name: id,
          label,
          isFooterAction: false,
          handleNavigation: () => {
            stepsDrawerCtxt.setSelectedIndex(viewIndex);
          },
          children
        };
        menu.push(menuItem);
      }
    });
    
    const signView = {
      index: "sign",
      name: "sign",
      label: i18n("nav_labels", "sign_agreement"),
      isFooterAction: false,
      handleNavigation: () => {
        if (!isLaptopOrDesktop) stepsDrawerCtxt.toggleDrawer();
        
        cobForm.current._onSubmit(null, {
          triggeredFrom: "CobStepsButton",
          viewIndex: "sign"
        });
      }
    };

    // Push signView to the end of the last menu item children array (might need a different approach)
    menu[menu.length - 1].children.push(signView);
  }

  const handleShareCaseClick = () => {
    if (isCobLoading) return;

    onShareOpen(caseId);
  };

  const handleQuitSessionClick = () => {
    if (isCobLoading) return;
    
    if (!showCaseSessionDialog) {
      toggleCaseSessionDialog();
    }
  };

  useEffect(() => {
    // Set the selected index to the current view number
    if (viewNumber) {
      if (viewNumber === "sign") {
        return stepsDrawerCtxt.setSelectedChild(viewNumber);
      }

      // Check steps if there's any subView with the same subViewIndex as viewNumber
      const subView = steps.reduce((found, item) => {
        if (found) return found;
        if (item.subViews) {
          return item.subViews.find(
            subView => subView.subViewIndex === viewNumber
          );
        }
        return null;
      }, null);

      if (subView) {
        return stepsDrawerCtxt.setSelectedChild(subView.id);
      }

      stepsDrawerCtxt.setSelectedChild(null);
    }
  }, [viewNumber]);

  return {
    open,
    customProps,
    menu,
    // nestedItems,
    // selectedIndex,
    selectedChild,
    // handleItemClick,
    isCobLoading,
    hasFormValidationErrors,
    handleChildClick,
    handleShareCaseClick,
    handleQuitSessionClick,
    toggleDrawer
  };
};

export default useStepsDrawer;
